import React from 'react';
import { Link } from 'react-router-dom';
import { PHASES } from '../lib/stepIcons';

/**
 * Segmented progress bar — 4 phase pills (Foundation / Outreach / Content / Launch).
 * Each pill fills proportionally as steps within that phase are completed.
 * The current step adds a pulsing teal dot at the right edge of its segment.
 */
export const SegmentedProgress = ({ steps, progress, currentStepNum, pathId, showLabels = true }) => {
  const isCompleted = (stepNum) => {
    const s = steps.find((st) => st.step_number === stepNum);
    if (!s) return false;
    return !!progress.find((p) => p.step_id === s.id && p.is_completed);
  };

  return (
    <div className="w-full" data-testid="segmented-progress">
      <div className="flex items-center gap-2">
        {PHASES.map((phase) => {
          const completedInPhase = phase.steps.filter(isCompleted).length;
          const fillPct = (completedInPhase / phase.steps.length) * 100;
          const phaseHasCurrent = phase.steps.includes(currentStepNum);
          return (
            <div key={phase.id} className="flex-1 min-w-0">
              <div
                className="relative h-2 rounded-full bg-slate-200/70 overflow-visible"
                style={{ backgroundColor: 'rgb(226 232 240 / 0.7)' }}
              >
                <div
                  className="absolute inset-y-0 left-0 rounded-full transition-all duration-500"
                  style={{
                    width: `${fillPct}%`,
                    background: `linear-gradient(to right, ${phase.color}, ${phase.color}cc)`,
                  }}
                />
                {phaseHasCurrent && (
                  <span
                    className="absolute top-1/2 -translate-y-1/2 w-2.5 h-2.5 rounded-full creataby-pulse-dot"
                    style={{
                      left: `calc(${((phase.steps.indexOf(currentStepNum) + 1) / phase.steps.length) * 100}% - 5px)`,
                      backgroundColor: phase.color,
                    }}
                    data-testid={`progress-current-dot-${phase.id}`}
                  />
                )}
              </div>
              {showLabels && (
                <p className="text-[10px] uppercase tracking-wider text-muted-foreground mt-1.5 text-center font-semibold">
                  {phase.emoji} {phase.label}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SegmentedProgress;
